import { render, staticRenderFns } from "./RegisterConfirmation.vue?vue&type=template&id=1ffa3299"
import script from "./RegisterConfirmation.vue?vue&type=script&lang=js"
export * from "./RegisterConfirmation.vue?vue&type=script&lang=js"
import style0 from "./RegisterConfirmation.vue?vue&type=style&index=0&id=1ffa3299&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports